module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-pagination', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px"
    },
    attrs: {
      "pager-count": 5,
      "page-sizes": [5, 10, 30],
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "layout": _vm.layout,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66e8176d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = 1159
// module chunks = 2